import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { useEramanOTP } from "../Contents.hook";
import { fields } from "../constants";

export const OneTimePassword = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const { data: editData, error, isLoading: drilldownLoading, isError, refetch: refetchEditData } = useEramanOTP();

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    } else {
      refetchEditData();
    }
  }, [query.get("id")]);

  const AwardsFormConfig: FormConfig = {
    initialValues: {
      title: decodeHTML(dataById ? dataById.payload.title : editData ? editData?.[0]?.title : ""),
      field_sign_uptext: decodeHTML(
        dataById ? dataById.payload.field_sign_uptext : editData ? editData?.[0]?.field_sign_uptext : ""
      ),
      field_sign_up_description: decodeHTML(
        dataById ? dataById.payload.field_sign_up_description : editData ? editData?.[0]?.field_sign_up_description : ""
      ),
      field_otp_request_text: decodeHTML(
        dataById ? dataById.payload.field_otp_request_text : editData ? editData?.[0]?.field_otp_request_text : ""
      ),
      field_repeat_again: decodeHTML(
        dataById ? dataById.payload.field_repeat_again : editData ? editData?.[0]?.field_repeat_again : ""
      ),
      field_upgrade_text: decodeHTML(
        dataById ? dataById.payload.field_upgrade_text : editData ? editData?.[0]?.field_upgrade_text : ""
      ),
    },
    fields: fields.eramanOTP,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["bannerImage"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    // let descKeys: any = [
    //   "field_sign_up_description",
    // ];
    // for (const key of descKeys) {
    //   try {
    //     data[key] = {
    //       value: data[key] || "",
    //       format: "full_html",
    //     };
    //   } catch (error) {}
    // }

    const payload = {
      action: action,
      method: method,
      module: "Contents",
      subModule: `eramanOTP`,
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editData?.[0]?.id || dataById?.payload?.id }),
        ...data,
        published: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <>
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={AwardsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${eramanHost}/api/registration-otp-page-crud-api/${editData?.[0]?.id || dataById?.payload?.id}`,
            "UPDATE",
            "PATCH",
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </>
  );
};
